/**
 * SA-1093 (spec R4): whether this viewer lets a thread's HTML mail load
 * remote images. Per viewer and per thread, in localStorage (the
 * `record-section:<id>` precedent): it survives a reload and never speaks
 * for another viewer. Every access is try/catch; a blocked store reads as
 * not allowed.
 */
const ALLOWED = 'allowed'

export function externalImagesKey(conversationId: string): string {
  return `inbox-external-images:${conversationId}`
}

export function isAllowed(conversationId: string): boolean {
  try {
    return window.localStorage.getItem(externalImagesKey(conversationId)) === ALLOWED
  } catch {
    return false
  }
}

/** True when the choice was stored. SA-1122: the pane keeps a choice in
 * memory only when storage refused it, so a stored one is read afresh. */
export function setAllowed(conversationId: string, value: boolean): boolean {
  try {
    if (value) window.localStorage.setItem(externalImagesKey(conversationId), ALLOWED)
    else window.localStorage.removeItem(externalImagesKey(conversationId))
    return true
  } catch {
    // Not remembered; the frames still follow the state in memory.
    return false
  }
}
